import { render, staticRenderFns } from "./SwitchCell.vue?vue&type=template&id=bfbe4462"
import script from "./SwitchCell.vue?vue&type=script&lang=js"
export * from "./SwitchCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {S2InputSwitch: require('/usr/src/app/node_modules/front-components/components/ui/form/InputSwitch.vue').default})
